import * as React from 'react';
import { Bem, addClass } from '../../utils/css.js';
import '../../constants.js';
import './Grid.scss.js';
import { Row } from './Row.js';
import { Col } from './Col.js';

const bem = Bem.create("vai-grid");
function Grid({ padding, children, className, dataTa, ...rest }) {
  return /* @__PURE__ */ React.createElement("div", {
    "data-ta": dataTa,
    className: addClass(bem.block(padding && `padding-${padding}`), className),
    ...rest
  }, children);
}
Grid.Row = Row;
Grid.Col = Col;

export { Grid };
